module.exports = __webpack_public_path__ + "img/bi-creates-new.1c8eccbe.png";